module.exports = __webpack_public_path__ + "img/6-narwhal_v8e_loading.fcd93c1a.jpg";